import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {BehaviorSubject, Observable, of, Subject} from 'rxjs';
import {map} from 'rxjs/operators';
import {RewardService} from '../services/reward.service';
import {CouponModel, UnclipRewardDetailModel} from '../models/data.model';
import {RewardModel} from '../services/data.model';
import {v4 as uuidv4} from 'uuid';
import {RewardsSummaryService} from '../services/rewards-summary.service';
import {environment} from "../../../environments/environment";
import {ParamService} from "./param.service";
import {AuthService} from "./auth.service";

// Window global declaration
function _window(): any {
    return window;
}

declare var $: any;

@Injectable({
    providedIn: 'root',
})
export class ClipService {
    banner = '';
    public rewardsRefreshSource = new Subject<boolean>();
    public rewardsRefresh = this.rewardsRefreshSource.asObservable();
    public rewardsModalRefreshSource = new Subject<boolean>();
    public rewardsModalRefresh = this.rewardsModalRefreshSource.asObservable();
    public disableAllButtons = new Subject<boolean>();
    public disableAllButtonsObservable = this.disableAllButtons.asObservable();
    public apiResponseSource = new BehaviorSubject<boolean>(false);
    public apiResponse = this.apiResponseSource.asObservable();
    //For Modal to Open
    public openRewardsModalSource = new Subject<boolean>();
    public openRewardModal = this.openRewardsModalSource.asObservable();

    public constructor(private _http: HttpClient, private _rewardService: RewardService, public _rewardSummaryService: RewardsSummaryService,
                       private paramService: ParamService, private authService: AuthService) {
        this.banner = this.paramService.banner
    }

    getLocationHref() {
        return window.location.href;
    }

    getLocationHost() {
        return window.location.host;
    }

    getApplicationDomainURL() {
        let domain;
        if (this.getLocationHref().indexOf('local') > 0) {
            domain = 'https://www-qa1.' + this.banner + '.com';
        } else {
            domain = 'https://' + this.getLocationHost();
        }
        return domain;
    }

    public replaceHeaderBanner(header) {
        if (header) {
            if (header['banner']) {
                header['banner'] = header['banner'].replace(/\{banner\}/g, this.banner);
            }
            if (header['x-swy_banner']) {
                header['x-swy_banner'] = header['x-swy_banner'].replace(/\{banner\}/g, this.banner);
            }
            if (header['X-SWY_BANNER']) {
                header['X-SWY_BANNER'] = header['X-SWY_BANNER'].replace(/\{banner\}/g, this.banner);
            }
            if (header['SWY_BANNER']) {
                header['SWY_BANNER'] = header['SWY_BANNER'].replace(/\{banner\}/g, this.banner);
            }
            if (header['X-Swy_banner']) {
                header['X-Swy_banner'] = header['X-Swy_banner'].replace(/\{banner\}/g, this.banner);
            }


        }
    }

    parseJwt(jwtToken) {
        const base64Url = jwtToken.split('.')[1];
        const base64 = base64Url.replace('-', '+').replace('_', '/');
        return JSON.parse(window.atob(base64));
    }

    getUserClaims(user) {
        const oktaToken = this.parseJwt(user.SWY_SHOP_TOKEN);
        const userClaims = {
            aln: oktaToken['aln'],
            hid: oktaToken['hid'],
            zip: oktaToken['zip'],
            gid: oktaToken['gid'],
            uuid: oktaToken['uuid'],
            exp: oktaToken['exp'],
            firstname: oktaToken['fnm'],
            lastname: oktaToken['lnm']
        };
        return userClaims;
    }

    public clipCoupon(coupon: CouponModel, callback, userInfo) {
        if (this.authService.isTokenValidForSession(userInfo)) {
            const httpOptions = {headers: new HttpHeaders(window['AB'].j4uHttpOptions)};
            let reqBody = {};
            if (coupon.deleted) {
                reqBody = {
                    items: [
                        {
                            clipType: 'L',
                            itemId: coupon.offerId,
                            itemType: coupon.offerPgm,
                        },
                    ],
                };
            } else {
                reqBody = {
                    items: [
                        {
                            clipType: 'C',
                            itemId: coupon.offerId,
                            itemType: coupon.offerPgm,
                        },
                        {
                            clipType: 'L',
                            itemId: coupon.offerId,
                            itemType: coupon.offerPgm,
                        },
                    ],
                };
            }


            this._http.post(window['AB']['couponClipPath'], reqBody, httpOptions)
                .subscribe((response) => {
                    const allCoupons = JSON.parse(localStorage.getItem('abCoupons'));
                    if (allCoupons && allCoupons.offers) {
                        allCoupons.offers[coupon.id].status = 'C';
                        localStorage.setItem('abCoupons', JSON.stringify(allCoupons));
                    }
                    callback();
                }, err => console.error('clip error', err));

        } else {
            if (window['SWY']['CONFIGSERVICE'] && window['SWY']['CONFIGSERVICE'].featureToggleConfig && window['SWY']['CONFIGSERVICE'].featureToggleConfig.enableWebOTP) {
                _window().AB.COMMON.showSignInModal_OTP();
            } else {
                _window().AB.COMMON.showCreateAccontModalJ4U();
            }
        }
    }

    public clipReward(reward: RewardModel, callback, rewardNewRefreshDisabled, userInfo, currentEnvironment, isCashReward, isPointsonly, isBoostYourPointsCardFlow) {
        let httpOptions: any;
        const headerObj = environment[currentEnvironment].rewardsLookupConfig.j4uHttpOptions;
        this.replaceHeaderBanner(headerObj);
        httpOptions = {
            headers: {
                ...headerObj,
                'X-Swyconsumerdirectorypro': userInfo.SWY_SHOP_TOKEN,
                'Swy_sso_token': userInfo.SWY_SHOP_TOKEN,
                'x-swy-correlation-id': uuidv4()
            }
        };
        let storeId;
        storeId = this._rewardSummaryService.getStoreIdForUserType(userInfo);
        const rewardUrl = this.getApplicationDomainURL() + environment[currentEnvironment].rewardsLookupConfig.couponClipPath + '?storeId=' + storeId;
        const reqBody = {
            items: [
                {
                    clipType: 'C',
                    itemId: isBoostYourPointsCardFlow ? reward.offerId : reward.groceryRewardId,
                    itemType: reward.offerPgm,

                },
                {
                    clipType: 'L',
                    itemId: isBoostYourPointsCardFlow ? reward.offerId : reward.groceryRewardId,
                    itemType: reward.offerPgm,

                },
            ],
        };

        this._http.post(rewardUrl, reqBody, httpOptions)
            .subscribe((response) => {
                this.apiResponseSource.next(false);
                if (response && response['items']) {
                    // Got the response with Items
                    const items = response['items'];
                    // look for the error codes in the response
                    if (items[0]['status'] === 1) {
                        // Success
                        this._rewardService.getRemoteDataMulticlip(userInfo, currentEnvironment, true).subscribe(data => {
                            if (items[0].clipType === 'C' && isCashReward) {
                                this._rewardSummaryService.hideGallerySource.next(true);
                            }

                            this._updateRewardsAnalytics(reward);

                            this.setToastindicator();
                            // Refresh the page after all is success
                            // need to add timeout so that analytics call fires successfully
                            if (isPointsonly) {
                                this._rewardSummaryService.$initPointScorecard.next(items[0]);
                            } else {
                                this._rewardSummaryService.$initRewardScorecard.next(items[0]);
                            }
                            if (rewardNewRefreshDisabled) {
                                setTimeout(function () { window.location.href = '/rewards/dashboard'; }, 500);
                            } else {
                                // window['AB'] && window['AB'].LOYALTY && window['AB'].LOYALTY.initRewardScorecard();
                                callback && callback()
                            }

                        });
                    } else {
                        this._handleErrorMessage(reward, items);
                    }
                } else {
                    this._handleErrorMessage(reward, []);
                }
            }, err => {
                console.error('clip error', err);
                this.apiResponseSource.next(false);
                let strError = err.status + ': Rewards Clip failed';
                if (err.error && err.error.items && Array.isArray(err.error.items) && err.error.items.length > 0) {
                    this._handleErrorMessage(reward, err.error.items);
                } else if (err.message && err.status) {
                    strError += ' ' + err.message + ' ' + err.status;
                    this._handleErrorMessage(reward, []);
                }
                window['AB']['DATALAYER'].setError(reward.groceryRewardId.toString(), 'rewards clipping', strError);
            });
    }

    public checkUnclipDetail(reward: RewardModel, userInfo, currentEnvironment) {
        if (this.authService.isTokenValidForSession(userInfo)) {
            const clipId = reward.usageType === 'M' ? reward.clipDetails.clipped[0] : reward.clipId;
            const hhId = window['AB']['userInfo']['houseId'];
            const headerObj = environment[currentEnvironment].rewardsLookupConfig.xAPIOcrpRewardsHttpOptionsV2;
            this.replaceHeaderBanner(headerObj);
            let httpOptions: any;
            httpOptions = {
                headers: {
                    ...headerObj,
                    'x-swy-correlation-id': uuidv4(),
                    Authorization: "Bearer " + userInfo.SWY_SHOP_TOKEN,
                }
            };
            const userClaims = this.getUserClaims(userInfo);
            const checkUnclipDetailUrl = this.getApplicationDomainURL() + environment[currentEnvironment].rewardsLookupConfig.checkUnclipDetail + '/' + userClaims.hid + '/' + clipId;
            return this._http.get(checkUnclipDetailUrl, httpOptions)
                .pipe(map((response) => {
                    const unclipRewardDetail: UnclipRewardDetailModel = new UnclipRewardDetailModel;
                    if (response) {

                        unclipRewardDetail['clipId'] = response['clipId'];
                        unclipRewardDetail['expiredRewards'] = response['expiredRewards'];
                        unclipRewardDetail['hhid'] = response['hhid'];
                        unclipRewardDetail['isPartiallyExpired'] = response['isPartiallyExpired'];
                        unclipRewardDetail['isValidForUnClip'] = response['isValidForUnClip'];
                        unclipRewardDetail['totalClippedRewards'] = response['totalClippedRewards'];
                        unclipRewardDetail['expiredPoints'] = response['expiredPoints'];
                        unclipRewardDetail['totalClippedPoints'] = response['totalClippedPoints'];
                    }
                    return unclipRewardDetail;
                }));
        }
    }

    public unclipRewardMulticlip(reward: RewardModel, callback, rewardNewRefreshDisabled, userInfo, currentEnvironment, isCashReward, isPointsonly) {
        if (this.authService.isTokenValidForSession(userInfo)) {
            this.doUnclipRewardMulticlip(reward, callback, rewardNewRefreshDisabled,userInfo, currentEnvironment, isCashReward, isPointsonly);
        } else {
            reward.isConfirmModalButtonDisabled = false;
            this.authService.getSSORoute(userInfo)
        }
    }

    public doUnclipRewardMulticlip(reward: RewardModel, callback, rewardNewRefreshDisabled,userInfo, currentEnvironment, isCashReward, isPointsonly) {
        let httpOptions: any;
        let headerObj = environment[currentEnvironment].rewardsLookupConfig.j4uHttpOptions;
        this.replaceHeaderBanner(headerObj);
        httpOptions = {
            headers: {
                ...headerObj,
                Authorization: "Bearer " + userInfo.SWY_SHOP_TOKEN,
                'x-swy-correlation-id': uuidv4()
            }
        };
        let unclipURL = this.getApplicationDomainURL() + environment[currentEnvironment].rewardsLookupConfig.rewardUnclipPath;
        let storeId;
        storeId = this._rewardSummaryService.getStoreIdForUserType(userInfo);
        unclipURL = unclipURL.replace('{storeId}', storeId);
        const reqBody = {
            items: [
                {
                    clipId: reward.clipDetails.clipped[0],
                },
            ],
        };
        this._http.post(unclipURL, reqBody, httpOptions)
            .subscribe((response) => {
                this.apiResponseSource.next(false);
                if (response['items']) {
                    const items = response['items'];
                    if (items[0]['status'] === 1) {
                        this._rewardService.getRemoteDataMulticlip(userInfo, currentEnvironment, true).subscribe(data => {
                            this._updateRewardsUnclipAnalytics(reward);
                            this.setToastindicator();
                            if (isPointsonly) {
                                this._rewardSummaryService.$initPointScorecard.next(items[0]);
                            } else {
                                this._rewardSummaryService.$initRewardScorecard.next(items[0]);
                            }
                            if (rewardNewRefreshDisabled) {
                                setTimeout(function () { window.location.href = '/rewards/dashboard'; }, 500);
                            } else {
                                // window['AB'] && window['AB'].LOYALTY && window['AB'].LOYALTY.initRewardScorecard();
                                callback && callback()
                            }
                        });


                    } else {
                        this._handleErrorMessage(reward, []);
                    }
                } else {
                    this._handleErrorMessage(reward, []);
                }
            }, err => {
                console.error('Unclip error', err);
                this.apiResponseSource.next(false);
                let strError = err.status + ': Rewards UnClip failed';
                if (err.error && err.error.items && Array.isArray(err.error.items) && err.error.items.length > 0) {
                    this._handleErrorMessage(reward, err.error.items);
                } else if (err.message && err.status) {
                    strError += ' ' + err.message + ' ' + err.status;
                    this._handleErrorMessage(reward, []);
                }
                window['AB']['DATALAYER'].setError(reward.groceryRewardId.toString(), 'rewards Unclipping', strError);
            });

    }

    public unclipReward(reward: RewardModel, callback, rewardNewRefreshDisabled, userInfo, currentEnvironment, isCashReward, isPointsonly) {

        let httpOptions: any;
        const headerObj = environment[currentEnvironment].rewardsLookupConfig.rewardUnclipHttpOptions;
        this.replaceHeaderBanner(headerObj);
        httpOptions = {
            headers: {
                ...headerObj,
                'Authorization': `Bearer ${userInfo.SWY_SHOP_TOKEN}`,
                'x-swy-correlation-id': uuidv4()
            }
        };

        let unclipURL = this.getApplicationDomainURL() + environment[currentEnvironment].rewardsLookupConfig.rewardUnclipPath;
        let storeId;
        storeId = this._rewardSummaryService.getStoreIdForUserType(userInfo);
        unclipURL = unclipURL.replace('{storeId}', storeId);
        const reqBody = {
            items: [
                {
                    clipId: reward.clipId,
                },
            ],
        };
        this._http.post(unclipURL, reqBody, httpOptions)
            .subscribe((response) => {
                this.apiResponseSource.next(false);
                if (response['items']) {
                    const items = response['items'];
                    if (items[0]['status'] === 1) {
                        this._rewardService.getRemoteDataMulticlip(userInfo, currentEnvironment, true).subscribe(data => {
                            if (items[0].clipType === 'U') {
                                this._rewardSummaryService.hideGallerySource.next(false);
                            }

                            this._updateRewardsUnclipAnalytics(reward);
                            this.setToastindicator();
                            if (isPointsonly) {
                                this._rewardSummaryService.$initPointScorecard.next(items[0]);
                            } else {
                                this._rewardSummaryService.$initRewardScorecard.next(items[0]);
                            }
                            if (rewardNewRefreshDisabled) {
                                setTimeout(function () { window.location.href = '/rewards/dashboard'; }, 500);
                            } else {
                                // window['AB'] && window['AB'].LOYALTY && window['AB'].LOYALTY.initRewardScorecard();
                                callback && callback()
                            }

                        });

                    } else {
                        this._handleErrorMessage(reward, []);
                    }
                } else {
                    this._handleErrorMessage(reward, []);
                }
            }, err => {
                console.error('Unclip error', err);
                this.apiResponseSource.next(false);
                let strError = err.status + ': Rewards UnClip failed';
                if (err.error && err.error.items && Array.isArray(err.error.items) && err.error.items.length > 0) {
                    this._handleErrorMessage(reward, err.error.items);
                } else if (err.message && err.status) {
                    strError += ' ' + err.message + ' ' + err.status;
                    this._handleErrorMessage(reward, []);
                }
                window['AB']['DATALAYER'].setError(reward.groceryRewardId.toString(), 'rewards Unclipping', strError);
            });

    }

    private setToastindicator() {
        if (localStorage.getItem('rewardToastShow')) {
            localStorage.removeItem('rewardToastShow');
        }
        localStorage.setItem('rewardToastShow', '200');

    }

    private _handleErrorMessage(reward: RewardModel, items) {
        let errorTitle: string
            , errorMessage: string
            , strSystemError: string
            , updateLocalCache = true;

        if (items && items.length > 0) {
            strSystemError = '400: Rewards Clip failed - status is 0';
            if (items[0].errorCd && items[0].errorMsg) {
                strSystemError += ' ' + items[0].errorCd + ' ' + items[0].errorMsg;
            }

            if (items[0]['errorCd'] && (items[0]['errorCd'] === 'EMJOC8024E' || items[0]['errorCd'] === 'EMJOC8025E')) {
                // Show Insufficient Balance message.
                errorTitle = 'Oops';
                errorMessage = 'Your reward balance is being updated, please check back in a few minutes.';
                updateLocalCache = false;
            } else if (items[0]['errorCd'] && (items[0]['errorCd'] === 'EMJOC4007E')) {
                errorTitle = 'Oops';
                errorMessage = 'You have already clipped this offer.';
            }
            else {
                // Show Generic Error
                errorTitle = 'Service Problem';
                errorMessage = 'System is currently unavailable, please try again later.';
            }
        } else {
            // Show Generic Error
            strSystemError = '400: Rewards Clip failed - items is not defined. ';

            errorTitle = 'Service Problem';
            errorMessage = 'System is currently unavailable, please try again later.';
        }

        // Hide the Modal in case of error.
        const modalID = '#rewards-redemption-confirmation-modal-' + reward.groceryRewardId;
        $(modalID).modal('hide');

        // Show error message
        window['AB']['COMMON'].popupUserErrorMessage(errorTitle, errorMessage, function () {
            // Refresh the page after user clicks the button.
            let targetStr = window.location.pathname + window.location.search;
            window.location.href = targetStr;
        });

        if (updateLocalCache) {
            localStorage.removeItem('abRewards');
        }

        window['AB']['DATALAYER'].setError(reward.groceryRewardId.toString(), 'rewards clipping', strSystemError);
    }

    private _updateRewardsAnalytics(reward: RewardModel) {
        window['AB']['DATALAYER'].clipReward(reward);
    }

    private _updateRewardsUnclipAnalytics(reward: RewardModel) {
        window['AB']['DATALAYER'].unclipReward(reward);
    }

    // Update the local storage for temporary storing the rewards.
    private _updateLocalStorageRewardsInfo(reward: RewardModel, isClip: boolean) {
        let rewardsAvailable = 0;
        let rewardExpire;

        const abRewardsSummaryLS = localStorage.getItem('abRewardsSummary');
        if (this._rewardSummaryService.checkSummaryTime(abRewardsSummaryLS)) {
            const objRewardsPoints = JSON.parse(abRewardsSummaryLS);
            if (isClip) {
                rewardsAvailable = objRewardsPoints.rewardsAvailable - reward.rewardsRequired;
                rewardExpire = (objRewardsPoints.rewardsExpire > reward.rewardsRequired) ?
                    objRewardsPoints.rewardsExpire - reward.rewardsRequired : 0;

            } else {
                rewardsAvailable = objRewardsPoints.rewardsAvailable + reward.rewardsRequired;
                rewardExpire = (objRewardsPoints.rewardsExpire > reward.rewardsRequired) ?
                    objRewardsPoints.rewardsExpire : 0;

            }
            // If the rewardReq is greater then the expRewards
            // replace it with Zero.
            // else (expReward - rewardReq)
            const time = Date.now();
            const abRewardsSummary = {
                'rewardsAvailable': rewardsAvailable,
                'rewardsExpire': rewardExpire,
                'savedTime': time
            };
            localStorage.setItem('abRewardsSummary', JSON.stringify(abRewardsSummary));
        } else {
            if (isClip) {
                rewardsAvailable = reward.rewardsAvailable - reward.rewardsRequired;
                rewardExpire = (reward.rewardsExpire > reward.rewardsRequired) ? (reward.rewardsExpire - reward.rewardsRequired) : 0;

            } else {
                rewardsAvailable = reward.rewardsAvailable + reward.rewardsRequired;
                rewardExpire = (reward.rewardsExpire > reward.rewardsRequired) ? (reward.rewardsExpire) : 0;
            }
            const time = Date.now();
            const abRewardsSummary = {
                'rewardsAvailable': rewardsAvailable,
                'rewardsExpire': rewardExpire,
                'savedTime': time
            };
            localStorage.setItem('abRewardsSummary', JSON.stringify(abRewardsSummary));
        }
    }
}
